import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { LocatorService } from 'src/app/core/locator.service';
// import * as $ from 'jquery';
declare var $:any;
// declare var dialog:any;


@Component({
  selector: 'home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit, AfterViewInit {

  formzip: any;
  formname: any;

  //clientID = '5cda305ffe9d4303d8bef6c5';
  // clientID = '5cdbf8b3e42f02081a6a9d2c';
  clientID = '5cf51d6058a39c22c1d2a896';

  searching: Boolean = false;
  searchingFind: Boolean = false;
  pros: any;
  closest: any;
  txtCaptcha: any = Math.floor(100000 + Math.random() * 900000).toString();
  txtInput: any;

  constructor(
    private formBuilder: FormBuilder,
    private locatorService: LocatorService
    ) { 
      this.createForm();
    }

    ngAfterViewInit() {

      $( "#dialog-result" ).dialog({
        autoOpen: false,
        resizable: false,
        height: "auto",
        width: 450,
        modal: true
      });
      $( "#dialog-res" ).dialog({
        autoOpen: false,
        resizable: false,
        height: "auto",
        width: 450,
        modal: true
      });
      $( "#dialog-noresult" ).dialog({
        autoOpen: false,
        resizable: false,
        height: "auto",
        width: 250,
        modal: true
      });

      $( "#dialog-confirm" ).dialog({
        autoOpen: false,
        resizable: false,
        height: "auto",
        width: 350,
        modal: true,
        buttons: {
          "Submit": () => {
            if (this.txtCaptcha === this.txtInput) {
              this.SearchPro();
              $("#dialog-confirm").dialog( "close" );
              this.txtCaptcha = Math.floor(100000 + Math.random() * 900000).toString();
              this.txtInput = '';
            } else {
              console.log('not match');
              this.txtCaptcha = Math.floor(100000 + Math.random() * 900000).toString();
            }
          }
        }
      });
      $( "#dialog-confirm2" ).dialog({
        autoOpen: false,
        resizable: false,
        height: "auto",
        width: 350,
        modal: true,
        buttons: {
          "Submit": () => {
            if (this.txtCaptcha === this.txtInput) {
              this.searchZip();
              $("#dialog-confirm2").dialog( "close" );
              this.txtCaptcha = Math.floor(100000 + Math.random() * 900000).toString();
              this.txtInput = '';
            } else {
              console.log('not match');
              this.txtCaptcha = Math.floor(100000 + Math.random() * 900000).toString();
            }
          }
        }
      });
      // $("#dialog-confirm").find("#txtCaptcha").val(Math.floor(100000 + Math.random() * 900000));
    }

  verification(event) {
    if(event === 'rep') {
      $("#dialog-confirm").dialog("open");
    } else {
      $("#dialog-confirm2").dialog("open");
    }
  }
  
    createForm() {
      this.formname = this.formBuilder.group({
        firstname: ['', Validators.required],
        lastname: ['', Validators.required],
        clientid: '5cf51d6058a39c22c1d2a896'
      })
      this.formzip = this.formBuilder.group({
        firstname: ['', Validators.required],
        lastname: ['', Validators.required],
        email: ['', Validators.required],
        street: [''],
        city: ['', Validators.required],
        zip: [''],
        subscribe: [false],
        find: [],
        clientid: '5cf51d6058a39c22c1d2a896'
      })
    }

  findLists(type) {
    if(type === 'host') {
      console.log(type);
      console.log('locator...');
      this.locatorService.cities = [];
      this.locatorService.GetAllStudents(this.clientID).subscribe((res: any) => {
        this.locatorService.cities = res;
        console.log('pros: ', res)
      })
    } else {
      console.log(type);
      console.log('locator...');
      this.locatorService.cities = [];
      this.locatorService.GetAllStudents2(this.clientID).subscribe((res: any) => {
        this.locatorService.cities = res;
        console.log('pros: ', res)
      })
    }
  }

  ngOnInit() {
    // console.log('locator...');
    // this.locatorService.cities = [];
    // this.locatorService.GetAllStudents(this.clientID).subscribe((res:any) => {
    //    this.locatorService.cities = res;
    //    console.log('pros: ',res)
    // })
    this.findLists('host');
  }

  searchZip() {
    this.locatorService.SaveSearch(this.formzip.value).subscribe((res:any) => {
      console.log(res)
      this.closest = [];
      this.searchingFind = true;
      this.locatorService.UserLocation(`${this.formzip.value['street']}, ${this.formzip.value['city']}, ${this.formzip.value['zip']}`).then((res: any) => {

      this.closest = res;
      console.log(this.closest);
      this.searchingFind = false;
      $("#dialog-res").dialog("open");


    })
      .catch((error) => {
        if (error == 'ZERO_RESULTS') {
          console.log('ZERO_RESULTS');
          this.locatorService.UserLocation(`${this.formzip.value['zip']}`).then((res: any) => {

            this.closest = res;
            console.log(this.closest);
            this.searchingFind = false;
            $("#dialog-res").dialog("open");
          })
            .catch((error) => {
              if (error == 'ZERO_RESULTS') {
                $("#dialog-noresult").dialog("open");
              }
              console.log(error);
              this.searchingFind = false;
            }
            )
        }
        console.log(error);
        this.searchingFind = false;
      })
    })
  }

  SearchPro(){
    console.log('searching...', this.formname.value);
    this.searching = true;

    this.locatorService.SearchPro(this.formname.value).subscribe((res:any) => {
      console.log(res);
      if(res) {
        setTimeout(() => {
          $("#dialog-result").dialog("open");
          this.searching = false;
          this.pros = res
        }, 1000);
      }
      else{
       // alert('Ops! Sorry, No Pro data found. Kindly try again.');
       $("#dialog-noresult").dialog("open");
        this.searching = false;
      }
    })
  }

  toggleForm() {
    this.searching = false;
    this.pros = [];
  
  }

  toggleFormzip() {
    
    this.searchingFind = false;
    this.closest = [];
  }
}
